export default Object.freeze({
  TokenExpired: 'token_expired',
  Connected: 'connected',
  Synced: 'synced',
  UnSynced: 'unsynced',
  SyncedFailed: 'sync_failed',
  Syncing: 'syncing',
  NotRelated: 'not_related',
});
